/**
 * Ky Tea — Custom Homepage JS
 * Handles: hero video scrub, features intersection, product card videos, scroll reveal
 * NOTE: Nav scroll state, hamburger toggle, and the Shop dropdown are handled
 * globally by snippets/kyt-nav.liquid — do not duplicate that logic here.
 * This file loads on the homepage AND on collection pages (collection.ky-tea.liquid),
 * so any nav-related code here would double up with kyt-nav.liquid's listeners
 * on both of those templates.
 */

(function () {
  'use strict';

  /* ── Utility ───────────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ── 1. HERO FRAME SCRUB ──────────────────────── */
  function initHeroScrub() {
    const hero = qs('.kyt-hero');
    const img = document.getElementById('kyt-hero-frame');
    const frames = (window.KYT_CONFIG && window.KYT_CONFIG.heroFrames) || [];
    if (!hero || !img || !frames.length) return;

    const total = frames.length;
    let current = 0;

    // Preload all frames up front so swaps are instant
    frames.forEach(function (src) {
      var pre = new Image();
      pre.src = src;
    });

    function update() {
      var heroH = hero.offsetHeight;
      var progress = Math.min(Math.max(window.scrollY / heroH, 0), 1);
      var idx = Math.min(Math.round(progress * (total - 1)), total - 1);
      if (idx !== current) {
        current = idx;
        img.src = frames[idx];
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── 2. FEATURES ── IntersectionObserver statements ───── */

  // Feature media map — URLs injected by sections/ky-tea-homepage.liquid via window.KYT_CONFIG
  const FEATURE_MEDIA = (window.KYT_CONFIG && window.KYT_CONFIG.featureMedia) || {};

  function initFeatures() {
    const items = qsa('.kyt-feature-item');
    const panel = qs('.kyt-features__panel');
    const panelMedia = qs('.kyt-features__panel-media');
    const panelCaption = qs('.kyt-features__panel-caption span');
    const thumbEl = qs('.kyt-features__thumb');
    if (!items.length) return;

    let currentKey = null;

    function activateItem(item) {
      items.forEach(function (i) { i.classList.remove('kyt-feature-item--active'); });
      item.classList.add('kyt-feature-item--active');

      const key = item.dataset.key;
      if (key === currentKey) return;
      currentKey = key;

      const media = FEATURE_MEDIA[key];
      if (!media) return;

      // Swap panel image
      if (panelMedia) {
        panelMedia.classList.add('kyt-features__panel-media--hidden');
        setTimeout(function () {
          panelMedia.src = media.src;
          panelMedia.classList.remove('kyt-features__panel-media--hidden');
        }, 280);
      }
      if (panelCaption) panelCaption.textContent = media.caption || '';

      // Mobile thumb
      if (thumbEl) {
        const thumbImg = qs('img', thumbEl) || qs('video', thumbEl);
        if (thumbImg) thumbImg.src = media.src;
      }
    }

    // Activate whichever item's center is closest to the viewport midpoint.
    // Works identically scrolling up or down — no IntersectionObserver edge cases.
    function updateActive() {
      var midY = window.innerHeight * 0.5;
      var best = null;
      var bestDist = Infinity;

      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var itemMidY = rect.top + rect.height / 2;
        var dist = Math.abs(itemMidY - midY);
        if (dist < bestDist) {
          bestDist = dist;
          best = item;
        }
      });

      if (best) activateItem(best);
    }

    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  }

  /* ── 3. PRODUCT CARD VIDEOS ─────────────────── */
  function initProductCardVideos() {
    const cards = qsa('.kyt-product-card');

    cards.forEach(function (card) {
      const video = qs('.kyt-product-card__video', card);
      if (!video) return;

      card.addEventListener('mouseenter', function () {
        video.currentTime = 0;
        video.play().catch(function () { /* autoplay may be blocked */ });
      });

      card.addEventListener('mouseleave', function () {
        video.pause();
      });
    });
  }

  /* ── 4. SCROLL REVEAL ── subtle fade-up for sections ───── */
  function initReveal() {
    const targets = qsa('[data-kyt-reveal]');
    if (!targets.length || !('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.style.opacity = '1'; t.style.transform = 'none'; });
      return;
    }

    targets.forEach(function (t) {
      t.style.opacity = '0';
      t.style.transform = 'translateY(24px)';
      t.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    });

    const revealObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'none';
            revealObs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    targets.forEach(function (t) { revealObs.observe(t); });
  }

  /* ── Init ────────────────────────────────────── */
  function init() {
    initHeroScrub();
    initFeatures();
    initProductCardVideos();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
